export default defineNuxtPlugin(() => {
  // 'dark' class is already set via htmlAttrs in nuxt.config.ts (SSR),
  // so no need to add it here. Just persist the preference for vueuse.
  localStorage.setItem('vueuse-color-scheme', 'dark')
})
